"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountResetPreviewAcceptButton = exports.mountPreviewAcceptBanner = void 0;
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("inline-preview-accept-banner");
var PreviewAcceptBanner = function () { return (react_1.default.createElement("div", { className: c() },
    react_1.default.createElement(icons_1.Preview, { size: icons_1.IconSize.Small }),
    react_1.default.createElement("div", { className: c("title") }, "Preview accept mode"),
    react_1.default.createElement("div", { className: c("description") }, "Click on the title to auto-fill"),
    react_1.default.createElement(kaleidoscope_1.Tooltip, { autoStack: true, size: kaleidoscope_1.TooltipSize.Large, content: "This is a preview of how your client will accept the page. Entering data here won't count as actually accepting the page" },
        react_1.default.createElement(icons_1.Help, { size: icons_1.IconSize.Small })))); };
var mountPreviewAcceptBanner = function (mountReactComponent) {
    return mountReactComponent(react_1.default.createElement(PreviewAcceptBanner, null));
};
exports.mountPreviewAcceptBanner = mountPreviewAcceptBanner;
var ResetPreviewAcceptButton = function (_a) {
    var onClick = _a.onClick;
    return (react_1.default.createElement(kaleidoscope_1.Button, { className: "inline-preview-accept__reset-button", type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: onClick },
        react_1.default.createElement(icons_1.Retry, null),
        "Reset preview accept"));
};
var mountResetPreviewAcceptButton = function (mountReactComponent, props) {
    return mountReactComponent(react_1.default.createElement(ResetPreviewAcceptButton, { onClick: function () { return props.onClick(); } }));
};
exports.mountResetPreviewAcceptButton = mountResetPreviewAcceptButton;
